import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';

@Component({
  template: `
    <fl-bit class="Header">
      <fl-heading
        i18n="Publish course modal header"
        [size]="HeadingSize.XSMALL"
        [headingType]="HeadingType.H4"
        [flMarginBottom]="Margin.SMALL"
      >
        Publish your course
      </fl-heading>
    </fl-bit>
    <fl-bit class="MainBody">
      <fl-text
        i18n="Publish course modal body"
        [flMarginBottom]="Margin.SMALL"
      >
        You're almost there! Once published, your course will be live immediately and students will be able to enroll. A published course is still editable and enrolled students will see these changes.
      </fl-text>
    </fl-bit>
    <div class="ActionContainer">
      <fl-button class="ActionButton"
        i18n="Publish course modal cancel button"
        [color]="ButtonColor.DEFAULT"
        [flMarginRight]="Margin.SMALL"
        (click)="cancel()"
      >
        Cancel
      </fl-button>
      <fl-button class="ActionButton"
        i18n="Publish course modal publish button"
        [color]="ButtonColor.SECONDARY"
        (click)="confirm()"
      >
        Publish
      </fl-button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./confirm-publish-course-modal.scss'],
})
export class ConfirmPublishCourseModalComponent {
  Margin = Margin;
  BannerAlertType = BannerAlertType;
  ButtonColor = ButtonColor;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;

  constructor(private modalRef: ModalRef<ConfirmPublishCourseModalComponent>) {}

  confirm() {
    this.modalRef.close(true);
  }

  cancel() {
    this.modalRef.close(false);
  }
}
